import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { CoreService } from '../services/core.service';
import { secureStorage } from '../shared/functions/secure-storage';
import {PageNumber, PageSize} from "../shared/variables/variables";

@Injectable({
  providedIn: 'root',
})
export class SingleReceiptResolver implements Resolve<boolean> {
  constructor(private coreService: CoreService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    const id = secureStorage.decryptItem(
      route.queryParams['id']?.replaceAll(' ', '+'),
    );
    const system = route.queryParams['system']
    const pageCode = route.queryParams['PageCode'];
    const cashierType = route.queryParams['cashierType']
      ? route.queryParams['cashierType']
      : 'CaPosX2';
    if (!system) {
      return this.coreService.getRequest(
        `Casher?id=${id}&CasherType=${cashierType}`,
      );
    } else {
      return this.coreService.getRequest(
        `Oneincome/api/Casher/GetAllCasher?NeededSystemActionCode=${system}&PageCode=${pageCode}&${id ? ('id=' + id + '&') : '' }PageNumber=${PageNumber}&PageSize=${PageSize}`,
        { observe: 'response', responseType: 'json' }, true, false
      );
    }
  }
}
